import { EarningMechanismAwardSelector } from '@occc-app/offerHelpers/components/earning-mechanism-award-selector';
import { ExternalFulfillmentValues } from '@occc-app/routes/AwardCatalog/types';
import { AwardType } from '@occc-app/offerHelpers/types';
import { useMakeOffersFilter } from '@occc-app/offerHelpers/hooks/use-make-offers-filter.hook';

type ExternalFulfillmentFormContentProps = {
  values: ExternalFulfillmentValues;
};

export const ExternalFulfillmentFormContent = ({ values }: ExternalFulfillmentFormContentProps) => {
  const makeOffersFilter = useMakeOffersFilter();

  return (
    <EarningMechanismAwardSelector
      buttonTypes={[AwardType.AwardNullable, AwardType.AwardPoints, AwardType.AwardVouchers]}
      fieldNamePrefix='externalFulfillment.'
      makeOffersFilter={makeOffersFilter}
      values={{
        awardType: values.externalFulfillment?.awardType || AwardType.AwardNullable,
      }}
    />
  );
};
